var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 28.5208L25 24.8542L29.8125 28.5208L27.9792 22.5833L32.8125 18.75H26.8958L25 12.8958L23.1042 18.75H17.1875L22 22.5833L20.1667 28.5208ZM41.6667 20.8333C41.6667 11.625 34.2083 4.16667 25 4.16667C15.7916 4.16667 8.33331 11.625 8.33331 20.8333C8.33331 25.0625 9.91665 28.8958 12.5 31.8333V47.9167L25 43.75L37.5 47.9167V31.8333C40.1863 28.799 41.6685 24.886 41.6667 20.8333ZM25 8.33334C31.8958 8.33334 37.5 13.9375 37.5 20.8333C37.5 27.7292 31.8958 33.3333 25 33.3333C18.1041 33.3333 12.5 27.7292 12.5 20.8333C12.5 13.9375 18.1041 8.33334 25 8.33334ZM25 39.5833L16.6666 41.7083V35.25C19.125 36.6667 21.9583 37.5 25 37.5C28.0417 37.5 30.875 36.6667 33.3333 35.25V41.7083L25 39.5833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.e755bf7019ce87f829bf71c11618bdd4.svg";
export { ForwardRef as ReactComponent };